import React, { useEffect, useState } from "react";
import '../Style/StudentsList.css';
import judicialLogo from '../Images/judicialLogo.png';
import { useDispatch, useSelector } from "react-redux";
import {
  getAllStudents,
  openAddStudentDialog,
  getAllCourses,
  hideCourses,
  openBulkActionDialog,
  openBulkCoursesDialog,
} from "../Redux/Dashboard/DashboardSlice";
import Spinner from "../Spinner/Spinner";
import { Notify } from "../CommonPopup/Popup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUserPlus, faChevronLeft, faChevronRight, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { blockStudent, changeUserPassword, deleteUser, paidUnpaidStudent, resetUserDevice } from "../Redux/Auth/AuthSlice";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { IoCloseCircleOutline } from "react-icons/io5";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import DeleteIcon from '@mui/icons-material/Delete';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { LockOutlined } from "@mui/icons-material";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";

const StudentsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const selector = useSelector((s) => s.DashboardSlice);
  const getStudents = selector.getStudents || [];
  const coursesData = selector.coursesData || [];
  const loader = selector.loader;

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const studentsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [showPaidModal, setShowPaidModal] = useState(false);
  const [selectedPaidStudent, setSelectedPaidStudent] = useState(null);

  const [showBlockModal, setShowBlockModal] = useState(false);
  const [selectedBlockedStudent, setSelectedBlockedStudent] = useState(null);

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [selectedDeleteUser, setSelectedDeleteUser] = useState(null);

  const [showResetDeviceModal, setShowResetDeviceModal] = useState(false);
  const [selectedResetDeviceUser, setSelectedResetDeviceUser] = useState(null);

  const [showCoursesModal, setShowCoursesModal] = useState(false);
  const [selectedStudentForCourses, setSelectedStudentForCourses] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showSelectOption, setShowSelectOption] = useState(false);

  const [showViewedVideos, setShowViewedVideos] = useState(false);
  const [videosCurrentPage, setVideosCurrentPage] = useState(1); // New state for videos pagination
  const videosPerPage = 3; // Limit to 3 videos per page

  useEffect(() => {
    dispatch(getAllStudents());
    dispatch(getAllCourses({ is_paid: "true" }));
  }, [dispatch]);

  useEffect(() => {
    if (selectedStudentForCourses && coursesData?.length) {
      const hiddenCourses = selectedStudentForCourses.hidden_courses || [];
      const initialSelected = coursesData.map((course) => ({
        id: course._id,
        title: course.title,
        checked: !hiddenCourses.includes(course._id),
      }));
      setSelectedCourses(initialSelected);
    }
  }, [selectedStudentForCourses, coursesData]);

  const filteredStudents = getStudents
    ?.filter((student) => {
      const name = student.name || '';
      const email = student.email || '';
      const phone = student.phone || '';
      return (
        name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        phone.includes(searchTerm)
      );
    })
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) || [];

  const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);
  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = filteredStudents.slice(indexOfFirstStudent, indexOfLastStudent);
  const handleEditCourses = (student) => {
    navigate("/HideCourses", { state: { student } });
  };

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handlePaidUnpaid = () => {
    const { _id, paid_account } = selectedPaidStudent;
    const newStatus = !paid_account;
    dispatch(paidUnpaidStudent({ userId: _id, paid: newStatus }))
      .unwrap()
      .then((data) => {
        Notify({ data: "success", msg: data?.message || "Status updated", type: "success" });
        dispatch(getAllStudents());
      })
      .catch((err) => {
        Notify({ data: "error", msg: err?.message || "Failed to update paid status", type: "error" });
      })
      .finally(() => {
        setShowPaidModal(false);
        setSelectedPaidStudent(null);
        dispatch(getAllStudents());
      });
  };

  const handleBlockUnblock = () => {
    const { _id, blocked } = selectedBlockedStudent;
    const newStatus = blocked === "false" ? true : false;
    dispatch(blockStudent({ userId: _id, blocked: newStatus }))
      .unwrap()
      .then((data) => {
        Notify({ data: "success", msg: data?.message || "Status updated", type: "success" });
        dispatch(getAllStudents());
      })
      .catch((err) => {
        Notify({ data: "error", msg: err?.message || "Failed to update block status", type: "error" });
      })
      .finally(() => {
        setShowBlockModal(false);
        setSelectedBlockedStudent(null);
        dispatch(getAllStudents());
      });
  };

  const handleDeleteUser = () => {
    dispatch(deleteUser(selectedDeleteUser._id))
      .unwrap()
      .then((data) => {
        Notify({ data: "success", msg: "User Deleted Successfully", type: "success" });

        // Calculate the new filtered students after deletion
        const newFilteredStudents = filteredStudents.filter(
          (student) => student._id !== selectedDeleteUser._id
        );
        const newTotalPages = Math.ceil(newFilteredStudents.length / studentsPerPage);

        // Check if the current page will be empty or invalid
        if (newFilteredStudents.length === 0) {
          // If no students left, reset to page 1
          setCurrentPage(1);
        } else if (
          currentPage > newTotalPages ||
          newFilteredStudents.slice((currentPage - 1) * studentsPerPage, currentPage * studentsPerPage).length === 0
        ) {
          // If current page is invalid or empty, go to the previous page
          setCurrentPage((prev) => Math.max(prev - 1, 1));
        }
        // Else, stay on the current page (no need to change currentPage)

        dispatch(getAllStudents());
      })
      .catch((err) => {
        Notify({ data: "error", msg: err?.message || "Failed to delete user", type: "error" });
      })
      .finally(() => {
        setShowDeleteUserModal(false);
        setSelectedDeleteUser(null);
        dispatch(getAllStudents());
      });
  };

  const handleResetDevice = () => {
    dispatch(resetUserDevice(selectedResetDeviceUser._id))
      .unwrap()
      .then((data) => {
        Notify({ data: "success", msg: "User Device Reset Successfully", type: "success" });
        dispatch(getAllStudents());
      })
      .catch((err) => {
        Notify({ data: "error", msg: "Failed to Reset user device", type: "error" });
      })
      .finally(() => {
        setShowResetDeviceModal(false);
        setSelectedResetDeviceUser(null);
        dispatch(getAllStudents());
      });
  };

  const handleChangePassword = () => {
    if (!newPassword || !confirmPassword) {
      Notify({ data: "error", msg: "All password fields are required", type: "error" });
      return;
    }
    if (newPassword !== confirmPassword) {
      Notify({ data: "error", msg: "New password and confirm password do not match", type: "error" });
      return;
    }

    dispatch(changeUserPassword({ userId: selectedUserForPassword._id, password: newPassword }))
      .unwrap()
      .then((res) => {
        Notify({ data: "success", msg: "Password changed successfully", type: "success" });
        setShowPasswordModal(false);
        setNewPassword("");
        setConfirmPassword("");
        setShowPassword(false);
        setShowConfirmPassword(false);
      })
      .catch((err) => {
        Notify({ data: "error", msg: "Failed to change password", type: "error" });
      });
  };

  const handlePasswordModalClose = () => {
    setShowPasswordModal(false);
    setNewPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
    setSelectedUserForPassword(null);
  };

  const handleOpenCoursesModal = (student) => {
    setSelectedStudentForCourses(student);
    setShowCoursesModal(true);
  };

  const handleOpenViewModal = (student) => {
    console.log("students", student);
    setSelectedStudent(student);
    setShowViewModal(true);
  };

  const handleCloseCoursesModal = () => {
    setShowCoursesModal(false);
    setSelectedStudentForCourses(null);
    setSelectedCourses([]);
  };

  const handleCourseChange = (courseId) => {
    setSelectedCourses((prev) =>
      prev.map((course) =>
        course.id === courseId ? { ...course, checked: !course.checked } : course
      )
    );
  };

  const handleSaveCourses = () => {
    const hiddenCourses = selectedCourses
      .filter((course) => !course.checked)
      .map((course) => course.id);

    dispatch(hideCourses({ userId: selectedStudentForCourses._id, courses: hiddenCourses }))
      .unwrap()
      .then((data) => {
        Notify({ data: "success", msg: "Hidden courses updated successfully", type: "success" });
        dispatch(getAllStudents());
      })
      .catch((err) => {
        Notify({ data: "error", msg: "Failed to update hidden courses", type: "error" });
      })
      .finally(() => {
        handleCloseCoursesModal();
      });
  };

  // Pagination for viewed videos
  const totalVideos = selectedStudent?.matched_videos?.length || 0;
  const totalVideoPages = Math.ceil(totalVideos / videosPerPage);
  const indexOfLastVideo = videosCurrentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = selectedStudent?.matched_videos?.slice(indexOfFirstVideo, indexOfLastVideo) || [];

  const nextVideoPage = () => {
    if (videosCurrentPage < totalVideoPages) setVideosCurrentPage(videosCurrentPage + 1);
  };

  const prevVideoPage = () => {
    if (videosCurrentPage > 1) setVideosCurrentPage(videosCurrentPage - 1);
  };


  const handleSelectAll = () => {
    // Select all users from filteredStudents (across all pages)
    const allUserIds = filteredStudents.map(student => ({ id: student._id, name: student?.name }));
    setSelectedUsers([...new Set(allUserIds)]);
  };

  const handleUnselectAll = () => {
    // Clear all selected users
    setSelectedUsers([]);
  };

  const handleSelectUser = (user) => {
    setSelectedUsers((prev) => {
      const exists = prev.some((u) => u.id === user.id);

      if (exists) {
        return prev.filter((u) => u.id !== user.id);
      } else {
        return [...prev, user];
      }
    });
  };

  const handleSelectPage = () => {
    const pageUsers = currentStudents.map((student) => ({
      id: student._id,
      name: student.name,
    }));

    setSelectedUsers((prev) => {
      const combined = [...prev, ...pageUsers];

      // remove duplicates
      const unique = combined.filter(
        (user, index, self) =>
          index === self.findIndex((u) => u.id === user.id)
      );

      return unique;
    });
  };

  const handleOpenSelectOption = () => {
    setShowSelectOption(true);
  };

  const handleCloseSelectOption = () => {
    setShowSelectOption(false);
    setSelectedUsers([]);
  };

  return (
    <div className="student-list-main">
      <img className="judicial-logo" src={judicialLogo} alt="Judicial Logo" />
      <h2 className="text-white">Students List ({getStudents.length})</h2>

      <div className="student-controls">
        <div className="student-search-container">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, or phone..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="search-input"
          />
        </div>
        <div className="d-flex gap-2">

          <button className="add-student-btn" onClick={() => dispatch(openAddStudentDialog(true))}>
            <FontAwesomeIcon icon={faUserPlus} /> Add Student
          </button>

          <div className="dropdown">
            <button
              className="bulk-action-btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              disabled={selectedUsers.length < 2}
            >
              Bulk Actions
            </button>

            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "paid",
                      })
                    )
                  }
                >
                  Mark as Paid
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "unpaid",
                      })
                    )
                  }
                >
                  Mark as Unpaid
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "block",
                      })
                    )
                  }
                >
                  Block Users
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "unblock",
                      })
                    )
                  }
                >
                  Unblock Users
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "reset",
                      })
                    )
                  }
                >
                  Reset Device
                </button>
              </li>

              {/* <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkCoursesDialog({
                        open: true,
                        users: selectedUsers,
                        action: "hide",
                      })
                    )
                  }
                >
                  Hide Courses
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    dispatch(
                      openBulkCoursesDialog({
                        open: true,
                        users: selectedUsers,
                        action: "unhide",
                      })
                    )
                  }
                >
                  Unhide Courses
                </button>
              </li> */}

              <li><hr className="dropdown-divider" /></li>

              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={() =>
                    dispatch(
                      openBulkActionDialog({
                        open: true,
                        users: selectedUsers,
                        action: "delete",
                      })
                    )
                  }
                >
                  Delete Users
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <button
        onClick={() => { !showSelectOption ? handleOpenSelectOption() : handleCloseSelectOption() }}
        className="btn text-white fw-semibold d-flex align-items-start gap-2"
        style={{
          padding: "12px 24px",
          borderRadius: "12px",
          background: "#3b82f6",
          border: "none",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#2563eb";
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#3b82f6";
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {showSelectOption ? "Close Select Option" : "Select Multiple Students"}
      </button>

      <div className="table-container mt-3">
        <table className="students-table">
          <thead>
            <tr>
              {
                showSelectOption && (
                  <th>
                    <div className="notification-action-buttons">
                      <button
                        className="notification-select-all-btn"
                        onClick={handleSelectAll}
                      >
                        Select All
                      </button>
                      <button
                        className="notification-unselect-all-btn"
                        onClick={handleUnselectAll}
                      >
                        Unselect All
                      </button>
                      <button
                        className="notification-select-all-btn"
                        onClick={handleSelectPage}
                      >
                        Select Page
                      </button>
                    </div>
                  </th>
                )
              }
              <th>Created At</th>
              <th>Name</th>
              <th>Email</th>
              <th>Date of Birth (MM/DD/YYYY)</th>
              <th>Phone</th>
              <th>Action</th>
            </tr>
          </thead>
          {loader ? (
            <tbody>
              <tr>
                <td colSpan="6">
                  <div className="spinner-wrapper">
                    <Spinner />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {currentStudents.length > 0 ? (
                currentStudents.map((student, index) => (
                  <tr key={index}>
                    {
                      showSelectOption && (
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedUsers.some(user => user.id === student._id)}
                            onChange={() => handleSelectUser({ id: student._id, name: student.name })}
                          />
                        </td>
                      )
                    }
                    <td>{new Date(student.created_at).toLocaleDateString()}</td>
                    <td>{student.name}</td>
                    <td>{student.email}</td>
                    <td>{student.dob ? new Date(student.dob).toLocaleDateString() : ""}</td>
                    <td>{student.phone}</td>
                    <td>
                      <div className="studentAction-btn-wrapper">
                        <div
                          className="studentAction-icon view-courses"
                          onClick={() => handleOpenViewModal(student)}
                        >
                          <VisibilityIcon style={{ color: 'green' }} />
                          <span className="tooltip">Student Details</span>
                        </div>

                        <div
                          className={`studentAction-icon ${student.blocked === "false" ? "block" : "unblock"}`}
                          onClick={() => {
                            setSelectedBlockedStudent(student);
                            setShowBlockModal(true);
                          }}
                        >
                          {student.blocked === "false" ? <LockOpenIcon /> : <LockOutlined />}
                          <span className="tooltip">
                            {student.blocked === "false" ? "Unblocked Student" : "Blocked Student"}
                          </span>
                        </div>

                        <div
                          className={`studentAction-icon ${student.paid_account ? "paid" : "unpaid"}`}
                          onClick={() => {
                            setSelectedPaidStudent(student);
                            setShowPaidModal(true);
                          }}
                        >
                          {student.paid_account ? <CurrencyRupeeIcon /> : <CurrencyRupeeIcon />}
                          <span className="tooltip">
                            {student.paid_account ? "Paid Account" : "Unpaid Account"}
                          </span>
                        </div>

                        {student.registered === false || student.registered === "false" ? (
                          <>
                            <div className="studentAction-icon disabled">
                              <VpnKeyIcon style={{ color: 'gray' }} />
                              <span className="tooltip">Change Password</span>
                            </div>
                            <div className="studentAction-icon disabled">
                              <SmartphoneIcon style={{ color: 'gray' }} />
                              <span className="tooltip">Reset Device Info</span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="studentAction-icon change-password"
                              onClick={() => {
                                setSelectedUserForPassword(student);
                                setShowPasswordModal(true);
                              }}
                            >
                              <VpnKeyIcon />
                              <span className="tooltip">Change Password</span>
                            </div>
                            <div
                              className="studentAction-icon reset-device"
                              onClick={() => {
                                setSelectedResetDeviceUser(student);
                                setShowResetDeviceModal(true);
                              }}
                            >
                              <SmartphoneIcon style={{ color: 'blue' }} />
                              <span className="tooltip">Reset Device Info</span>
                            </div>
                          </>
                        )}

                        <div className="studentAction-icon view-courses" onClick={() => handleEditCourses(student)}>
                          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "green", height: "20px" }} />
                          <span className="tooltip">Edit Courses</span>
                        </div>

                        <div
                          className="studentAction-icon delete"
                          onClick={() => {
                            setSelectedDeleteUser(student);
                            setShowDeleteUserModal(true);
                          }}
                        >
                          <DeleteIcon />
                          <span className="tooltip">Delete User</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="student-no-data">
                    No students found
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>

      {
        !loader && totalPages > 1 && (
          <div className="pagination">
            <button onClick={prevPage} disabled={currentPage === 1}>
              <FontAwesomeIcon icon={faChevronLeft} /> Prev
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button onClick={nextPage} disabled={currentPage === totalPages}>
              Next <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )
      }

      {/* View Student Details Modal */}
      {
        showViewModal && selectedStudent && (
          <div className="student-view-modal-overlay">
            <div className="student-view-modal-content">
              <div className="student-view-modal-header">
                <h5>Student Details</h5>
                <IoCloseCircleOutline
                  size={32}
                  onClick={() => {
                    setShowViewModal(false);
                    setShowViewedVideos(false);
                    setVideosCurrentPage(1); // Reset video pagination
                  }}
                  className="modal-close-icon"
                />
              </div>
              <div className="student-view-modal-body">
                <div className="student-view-modal-details">
                  <Stack direction="row" spacing={2} justifyContent="center" marginBottom={4}>
                    {selectedStudent.profile_image ? (
                      <a href={selectedStudent.profile_image} target="_blank" rel="noopener noreferrer">
                        <Avatar
                          alt={selectedStudent.name}
                          src={selectedStudent.profile_image}
                          sx={{
                            width: 140,
                            height: 140,
                            border: "4px solid #3b82f6",
                            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                            cursor: "pointer",
                          }}
                        />
                      </a>
                    ) : (
                      <div className="no-profile-image">
                        <Avatar
                          alt={selectedStudent.name}
                          sx={{
                            width: 140,
                            height: 140,
                            border: "4px solid #3b82f6",
                            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                            backgroundColor: "#e5e7eb",
                          }}
                        />
                        <span>No profile image added</span>
                      </div>
                    )}
                  </Stack>
                  <div className="student-view-details-grid">
                    <div className="student-view-detail-item">
                      <strong>Name:</strong> <span>{selectedStudent.name || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Email:</strong> <span>{selectedStudent.email || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Phone:</strong> <span>{selectedStudent.phone || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Date of Birth:</strong> <span>{selectedStudent.dob ? new Date(selectedStudent.dob).toLocaleDateString() : "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Gender:</strong> <span>{selectedStudent.gender || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Blood Group:</strong> <span>{selectedStudent.blood_group || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Nationality:</strong> <span>{selectedStudent.nationality || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Aadhaar Number:</strong> <span>{selectedStudent.aadhaar_number || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>PAN Number:</strong> <span>{selectedStudent.pan_number || "N/A"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Account Status:</strong> <span>{selectedStudent.paid_account ? "Paid" : "Unpaid"}</span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Blocked:</strong>
                      <span className={selectedStudent.blocked === "false" ? "status-green" : "status-red"}>
                        {selectedStudent.blocked === "false" ? "No" : "Yes"}
                      </span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Registered:</strong>
                      <span className={selectedStudent.registered === "true" ? "status-green" : "status-red"}>
                        {selectedStudent.registered === "true" ? "Yes" : "No"}
                      </span>
                    </div>
                    <div className="student-view-detail-item">
                      <strong>Created At:</strong> <span>{new Date(selectedStudent.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <div className="student-view-detail-item address-table">
                    <strong>Addresses:</strong>
                    <table className="student-view-address-table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Street</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Pincode</th>
                          <th>Country</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Correspondence</td>
                          <td>{selectedStudent.address?.correspondence?.street || "N/A"}</td>
                          <td>{selectedStudent.address?.correspondence?.city || "N/A"}</td>
                          <td>{selectedStudent.address?.correspondence?.state || "N/A"}</td>
                          <td>{selectedStudent.address?.correspondence?.pincode || "N/A"}</td>
                          <td>{selectedStudent.address?.correspondence?.country || "N/A"}</td>
                        </tr>
                        <tr>
                          <td>Permanent</td>
                          <td>{selectedStudent.address?.permanent?.street || "N/A"}</td>
                          <td>{selectedStudent.address?.permanent?.city || "N/A"}</td>
                          <td>{selectedStudent.address?.permanent?.state || "N/A"}</td>
                          <td>{selectedStudent.address?.permanent?.pincode || "N/A"}</td>
                          <td>{selectedStudent.address?.permanent?.country || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button
                      className="viewed-videos-toggle-btn"
                      onClick={() => setShowViewedVideos(!showViewedVideos)}
                    >
                      {showViewedVideos ? "Hide Student Watch History" : "Show Student Watch History"}
                    </button>
                    {showViewedVideos && (
                      <>
                        <div className="viewed-videos-dropdown">
                          {currentVideos.length > 0 ? (
                            <>
                              <table className="viewed-videos-table">
                                <thead>
                                  <tr>
                                    <th>Course Name</th>
                                    <th>Video Name</th>
                                    <th>Viewed Count</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentVideos.map((videoItem, index) => {
                                    const viewCount = selectedStudent.content_views?.find(
                                      (view) => view.content_id === videoItem.video._id
                                    )?.view_count || 0;
                                    return (
                                      <tr key={index}>
                                        <td>{videoItem.course_title || "N/A"}</td>
                                        <td>
                                          <a
                                            href={videoItem.video.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="viewed-videos-link"
                                          >
                                            {videoItem.video.name || "N/A"}
                                          </a>
                                        </td>
                                        <td>{viewCount}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                              {totalVideoPages > 1 && (
                                <div className="viewed-videos-pagination">
                                  <button
                                    onClick={prevVideoPage}
                                    disabled={videosCurrentPage === 1}
                                    className="viewed-videos-pagination-btn"
                                  >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                  </button>
                                  <span className="viewed-videos-page-number">{videosCurrentPage}</span>
                                  <button
                                    onClick={nextVideoPage}
                                    disabled={videosCurrentPage === totalVideoPages}
                                    className="viewed-videos-pagination-btn"
                                  >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="viewed-videos-no-data">No viewed videos found</div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="student-view-modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowViewModal(false);
                    setShowViewedVideos(false);
                    setVideosCurrentPage(1); // Reset video pagination
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Paid/Unpaid Confirmation Modal */}
      {
        showPaidModal && selectedPaidStudent && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Confirm Paid Status</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={() => setShowPaidModal(false)}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to mark <strong className="text-danger fw-bold">{selectedPaidStudent.name}</strong> as{" "}
                  <strong className="text-danger fw-bold">{selectedPaidStudent.paid_account ? "Unpaid" : "Paid"}</strong>?
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowPaidModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handlePaidUnpaid}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Block/Unblock Confirmation Modal */}
      {
        showBlockModal && selectedBlockedStudent && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Confirm Block Status</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={() => setShowBlockModal(false)}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to{" "}
                  <strong className="text-danger fw-bold">{selectedBlockedStudent.blocked === "false" ? "Block" : "Unblock"}</strong>{" "}
                  <strong className="text-danger fw-bold">{selectedBlockedStudent.name}</strong>?
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowBlockModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleBlockUnblock}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Delete User Modal */}
      {
        showDeleteUserModal && selectedDeleteUser && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Confirm Delete</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={() => setShowDeleteUserModal(false)}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to{" "}
                  <strong className="text-danger fw-bold">delete</strong>{" "}
                  <strong className="text-danger fw-bold">{selectedDeleteUser.name}</strong>?
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowDeleteUserModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleDeleteUser}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Reset Device Info Modal */}
      {
        showResetDeviceModal && selectedResetDeviceUser && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Confirm Reset Device</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={() => setShowResetDeviceModal(false)}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to{" "}
                  <strong className="text-danger fw-bold">Reset Device info of</strong>{" "}
                  <strong className="text-danger fw-bold">{selectedResetDeviceUser.name}</strong>?
                </p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowResetDeviceModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleResetDevice}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Change Password Modal */}
      {
        showPasswordModal && selectedUserForPassword && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Change Password for {selectedUserForPassword.name}</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={handlePasswordModalClose}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                <div className="input-group password-input">
                  <label className="fw-bold">New Password</label>
                  <div className="password-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter new password"
                    />
                    <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FiEyeOff /> : <FiEye />}
                    </span>
                  </div>
                </div>
                <div className="input-group password-input">
                  <label className="fw-bold">Confirm New Password</label>
                  <div className="password-wrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm new password"
                    />
                    <span className="toggle-password" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="UpdateUserButton-group">
                  <button
                    type="button"
                    className="reset-button"
                    onClick={handlePasswordModalClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="updateuser"
                    onClick={handleChangePassword}
                  >
                    Update Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Courses Modal */}
      {
        showCoursesModal && selectedStudentForCourses && (
          <div className="modal-overlay">
            <div className="modal-content courses-modal">
              <div className="modal-header">
                <h5>Manage Courses for {selectedStudentForCourses.name}</h5>
                <IoCloseCircleOutline
                  size={28}
                  onClick={handleCloseCoursesModal}
                  style={{ cursor: "pointer", color: "#f44336" }}
                />
              </div>
              <div className="modal-body">
                {selectedStudentForCourses.paid_account ? (
                  coursesData?.length ? (
                    <div className="courses-checkbox-list">
                      {selectedCourses.map((course) => (
                        <label key={course.id} className="course-checkbox-item">
                          <input
                            type="checkbox"
                            checked={course.checked}
                            onChange={() => handleCourseChange(course.id)}
                          />
                          <span className="course-title">{course.title}</span>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <p>No courses available.</p>
                  )
                ) : (
                  <p className="student-no-data">
                    This user account is not paid, first make the user account paid.
                  </p>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleCloseCoursesModal}>
                  Cancel
                </button>
                {selectedStudentForCourses.paid_account && (
                  <button
                    className="btn btn-primary"
                    onClick={handleSaveCourses}
                    disabled={!coursesData?.length}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default StudentsList;